import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h2>
              TekRevol Prepares Your <span>PWA</span> with{" "}
              <span>Cutting-edge</span> Tech Stacks
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              At TekRevol, our commitment is to ensure your PWA is equipped with
              exceptional technologies, and not only does it deliver across
              platforms and browsers, but it offers a smooth, app-like
              experience.
            </p>
            <p>
              Our development team is proficient in frontend frameworks like
              React, Vue.js, and AngularJS along with robust back-end
              technologies such as GraphQL and Node.js in the delivery of fairly
              fast and highly efficient PWAs, they can operate offline and are
              comparably safer when engaging with the users.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/Angular_JS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Angular JS</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/Bootstrap.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Bootstrap</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/CSS3.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>CSS</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/HTML5.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>HTML5</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/JavaScript.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>JavaScript</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/React.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>React</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/TypeScript.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>TypeScript</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/Vue.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>VueJs</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Backend">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/backend/Django.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Django</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/backend/Express.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Express JS</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/backend/GraphQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>GraphQL</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/backend/Java.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/backend/Node.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Node JS</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/backend/Python.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Python</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/backend/Ruby-on-Rails.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Ruby on Rails</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/backend/Spring_Boot.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Spring Boot</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Libraries">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/libraries/Axios.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Axios</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/libraries/jQuery.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>jQuery</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/libraries/Lodash.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Lodash</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/libraries/Redux.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Lodash</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Database">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/database/Firebase.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Firebase</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/database/MongoDB.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/database/MySQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>MySQL</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/database/PostgreSQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>PostgreSQL</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/database/SQLite.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>SQLite</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Others">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/others/AWS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/others/Docker.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Docker</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/others/Git.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Git</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/others/Jenkins.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Jenkins</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/others/Kubernetes.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Kubernetes</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/others/Nginx.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Nginx</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/others/Webpack.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Webpack</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="6" title="User Interface">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/user-interface/Adobe_XD.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Adobe XD</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/user-interface/Figma.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Figma</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/user-interface/In_Vision.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>In Vision</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/user-interface/Sketch.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Sketch</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/user-interface/Zeplin.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Zeplin</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
